import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function usePasswordResetRequestFormState() {
  return useAppState();
}

export function usePasswordResetRequestFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      passwordResetRequestForm: {
        email: '',
      },
    }));
  }

  function updateEmail(email) {
    dispatch((state) => ({
      ...state,
      passwordResetRequestForm: {
        ...state.passwordResetRequestForm,
        email,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    updateEmail,
    onResponse,
    onError,
    clearFeedback,
  };
}
